import React from 'react'
import { WhenIsPiping } from '@morningtrain/react-pipelines'
import LoadingSpinner from '../animations/LoadingSpinner'
import Text from '../formatting/Text'

export default function WithSpinner ({
  children,
  color = 'white'
}) {
  return (
    <Text className='flex space-x-3 items-center' block>
      <div>
        {children}
      </div>
      <WhenIsPiping>
        <LoadingSpinner color={color} />
      </WhenIsPiping>
    </Text>
  )
}
